export const COUNTRY_LIST_FETCH = 'COUNTRY_LIST_FETCH'
export const COUNTRY_LIST_FETCH_PENDING = 'COUNTRY_LIST_FETCH_PENDING'
export const COUNTRY_LIST_FETCH_ERROR = 'COUNTRY_LIST_FETCH_ERROR'
export const COUNTRY_LIST_FETCH_DONE = 'COUNTRY_LIST_FETCH_DONE'

export type FetchCountryListType = {
  language: string
  type: typeof COUNTRY_LIST_FETCH
}

export type ActionType = FetchCountryListType

export const countryListPending = () => ({
  type: COUNTRY_LIST_FETCH_PENDING
})

// TODO: Disabled for enforcing lint, fix if possible
// eslint-disable-next-line no-undef
export const countryListDone = (data: TsToDo) => ({
  type: COUNTRY_LIST_FETCH_DONE,
  data
})

export const countryListError = (error: Error) => ({
  type: COUNTRY_LIST_FETCH_ERROR,
  error
})

const fetchCountryList = (language: string): FetchCountryListType => ({
  type: COUNTRY_LIST_FETCH,
  language
})

export default fetchCountryList
